import { ApiEndpointConfig } from './api-endpoint-config';

const ENDPOINTS: Record<string, ApiEndpointConfig> = {
  visualPreview: {
    method: 'post',
    url: 'preview/visual-preview'
  },
  completePreview: {
    method: 'post',
    url: 'preview/complete-preview'
  }
};

// Programmatically add serviceType to all endpoints
Object.values(ENDPOINTS).forEach((api) => {
  (api as any).serviceType = 'preview';
});

export const PREVIEW_API_CONSTANTS = ENDPOINTS as typeof ENDPOINTS &
  Record<keyof typeof ENDPOINTS, { serviceType: string }>;
